import type { Device } from './useDevice';

export const CLAVE_TEMA = 'cqinv.tema';
export const CLAVE_FORZAR_DISPOSITIVO = 'cqinv.forceDevice';
export const EVENTO_PREFERENCIAS = 'cqinv-preferencias';

export type TemaVisual = 'claro' | 'oscuro';

export function leerTemaVisual(): TemaVisual {
  try {
    return localStorage.getItem(CLAVE_TEMA) === 'oscuro' ? 'oscuro' : 'claro';
  } catch {
    return 'claro';
  }
}

export function aplicarTemaVisual(tema: TemaVisual): void {
  if (tema === 'oscuro') {
    document.documentElement.setAttribute('data-tema', 'oscuro');
  } else {
    document.documentElement.removeAttribute('data-tema');
  }
}

export function guardarTemaVisual(tema: TemaVisual): void {
  localStorage.setItem(CLAVE_TEMA, tema);
  aplicarTemaVisual(tema);
  window.dispatchEvent(new Event(EVENTO_PREFERENCIAS));
}

export function leerDispositivoForzado(): Device | null {
  try {
    const v = localStorage.getItem(CLAVE_FORZAR_DISPOSITIVO);
    return v === 'movil' || v === 'escritorio' ? v : null;
  } catch {
    return null;
  }
}

export function guardarDispositivoForzado(device: Device | null): void {
  if (device) localStorage.setItem(CLAVE_FORZAR_DISPOSITIVO, device);
  else localStorage.removeItem(CLAVE_FORZAR_DISPOSITIVO);
  window.dispatchEvent(new Event(EVENTO_PREFERENCIAS));
}

function colorDesdeCanalesHsl(canales: string): string {
  return `${'hsl'}(${canales})`;
}

export function colorTemaDesdeHsl(canales: string | undefined): string {
  const valor = canales?.trim();
  if (valor) return colorDesdeCanalesHsl(valor);
  if (typeof document !== 'undefined') {
    const computed = getComputedStyle(document.documentElement).getPropertyValue('--brand-primary').trim();
    if (computed) return colorDesdeCanalesHsl(computed);
  }
  return colorDesdeCanalesHsl('var(--brand-primary)');
}

export function aplicarColorDeTema(hsl: string | undefined): void {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', colorTemaDesdeHsl(hsl));
}
